module.exports = ".row{\r\n    padding:5px 0px 0px;\r\n}\r\n\r\n.row:nth-child(odd){\r\n    background: #f3f3f3;\r\n}\r\n\r\n.form-group label{\r\n    color: #0000ff;    \r\n    font-size: 16px;\r\n    font-weight: normal\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/functions/lience-reuest/lience-reuest-form/lience-reuest-form.component.css
// module id = ./src/app/pages/functions/lience-reuest/lience-reuest-form/lience-reuest-form.component.css
// module chunks = main